<template>
    <div>
        <div>
            <h1 class="pb-2 mb-4 text-2xl leading-none border-b font-700 md:text-3xl lg:text-4xl lg:mb-8">{{ $t(fieldLabel) }}</h1>
            <div class="flex">
              <div class="flex flex-wrap pr-4 mb-4 input md:w-1/2">
                <div class="input__label">
                  <label class="text-xs leading-relaxed uppercase lg:text-sm font-700">{{ $t("contact.firstName") }}</label>
                </div>
                <div class="input__field ">
                  <input id="firstName" type="text" v-model="contact.firstName" required />
                  <div class="required-label" v-if="!contact.firstName || contact.firstName === ''">{{ $t("validation.requiredLabel") }}</div>
                </div>
              </div>

              <div class="flex flex-wrap pr-4 mb-4 input md:w-1/2">
                <div class="input__label">
                  <label class="text-xs leading-relaxed uppercase lg:text-sm font-700">{{ $t("contact.lastName") }}</label>
                </div>
                <div class="input__field">
                  <input id="lastName" type="text" v-model="contact.lastName" required />
                  <div class="required-label" v-if="!contact.lastName || contact.lastName === ''">{{ $t("validation.requiredLabel") }}</div>
                </div>
              </div>
            </div>

            <div class="flex">
              <Countries fieldLabel="contact.country" :currentCountryCode="contact.countryCode" v-model="contact.countryCode" v-on:changeCountry="setCountry" />
              <div class="required-label" v-if="!contact.countryCode || contact.countryCode === ''">{{ $t("validation.requiredLabel") }}</div>
            </div>

            <div class="flex">
              <div class="flex flex-wrap content-start pr-4 mb-4 input md:w-1/2">
                <div class="input__label">
                  <label class="text-xs leading-relaxed uppercase lg:text-sm font-700">{{ $t("contact.emailAddress") }}</label>
                </div>
                <div class="input__field ">
                  <input id="emailAddress" type="text" v-model="contact.emailAddress" required />
                  <div class="required-label" v-if="!contact.emailAddress || contact.emailAddress === ''">{{ $t("validation.requiredLabel") }}</div>
                </div>
              </div>

              <div class="flex flex-wrap content-start pr-4 mb-4 input md:w-1/2">
                <div class="input__label">
                  <label class="text-xs leading-relaxed uppercase lg:text-sm font-700">{{ $t("contact.mobile") }}</label>
                </div>
                <div class="input__field ">
                  <input id="mobilePhone" type="text" v-model="contact.mobileNumber" required />
                  <div class="required-label" v-if="!contact.mobileNumber || contact.mobileNumber === ''">{{ $t("validation.requiredLabel") }}</div>
                </div>
              </div>              
            </div>

            <div class="flex">
              <div class="flex flex-wrap content-start pr-4 mb-4 input md:w-1/2">
                <div class="input__label">
                  <label class="text-xs leading-relaxed uppercase lg:text-sm font-700">{{ $t("contact.dateOfBirth") }}</label>
                </div>
                <DatePicker fieldLabel="contact.dateOfBirth" :currentDate="contact.dateOfBirth" v-on:changeDate="setDayOfBirth" :isBirthday="true" />
                <div class="required-label required-label--inline" v-if="!contact.dateOfBirth || contact.dateOfBirth === ''">
                  {{ $t("validation.requiredLabel") }}
                </div>
                <div class="required-label required-label--inline" v-if="!DateOfBirthIsValid">
                  {{ $t("validation.ageRestriction",[minimumRentalAge])}}
                </div>
              </div>
            </div>
          </div>
    </div>
</template>

<script>
    import HtmlPropertyHelper from '@/mixins/HtmlPropertyHelper';
    import DateTimeHelper from '@/mixins/DateTimeHelper';
    import Countries from '@/components/Countries';
    import DatePicker from '@/components/DatePicker';
    import { mapGetters } from 'vuex'

    export default {
        name: 'Contact',
        mixins: [HtmlPropertyHelper, DateTimeHelper],
        components: {
            Countries,
            DatePicker,
        },
        props: {
            fieldLabel: String,
            currentContact: Object
        },
        data: () => ({
            contact: {
                firstName: null,
                middleName: null,
                lastName: null,
                gender: null,
                address: null,
                zip: null,
                city: null,
                state: null,
                countryCode: 'nl',
                country: null,
                emailAddress: null,
                phoneNumber: null,
                mobileNumber: null,
                dateOfBirth: null,
                birthPlace: null,
                alternativeAddress: null,
                alternativeEmail: null,
                identification: []
            },
            errors: []
        }),
        computed: {
            ...mapGetters([
              'reservation'
            ]),
            minimumRentalAge(){
              var minimumRentalAge = this.reservation.car.minimum_rental_age;
              if(minimumRentalAge == null) 
              {
                minimumRentalAge = 18;
              }
              return minimumRentalAge;
            },
            GetFirstIdentification() {
              this.initializeContact()
              if ( this.contact.identification && this.contact.identification.length > 0 ) {
                return this.contact.identification[0]
              }
              return null
            },
            DateOfBirthIsValid() {
              if ( this.contact.dateOfBirth ) {
                return this.differenceBetweenDateTimesInYears(this.getDateMinYears(), this.contact.dateOfBirth) >= this.minimumRentalAge
              }
              else return true
            }
        },
        created() {
          this.initializeContact();
        },
        watch: {
            contact: {
                deep: true,
                handler() {
                    this.$emit('changeContact', this.contact);
                }
            }
        },
        methods: {
            initializeContact() {
              if ( this.currentContact ) {
                this.contact = this.currentContact;
              }
            },
            setCountry(val) {
                this.contact.country = val;
                this.contact.countryCode = val.code2;
            },
            setDayOfBirth(val) {
                this.contact.dateOfBirth = val;
            },
            setIdentification(val) {
                this.contact.identification = [];
                this.contact.identification.push(val);
            }
        }
    }
</script>
